<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/rs8P7N/tc-custom/9781429983709.jpg?1718184629356" alt="This image is the cover for the book Queen of Candesce, Virga"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Queen of Candesce, Virga
      </h1>
      <p class="bookDescription body article font2">
        <p>Venera Fanning was last seen falling into nothingness at the end of <i>Sun of Suns</i>. Now, in <i>Queen of Candesce</i>, Venera finds herself plunging through the air between the artificial continents of Virga, far from home and her husband, who may or may not be alive.  Landing in the ancient nation of Spyre, Venera encounters new enemies and new friends (or at least convenient allies). She must quickly learn who she can trust, and who she can manipulate in order to survive. <i>Queen of Candesce</i> is her story.<br/><br/><br/><br/>At the Publisher's request, this title is being sold without Digital Rights Management Software (DRM) applied.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Karl Schroeder
      </h2>
      
      <p class="authorDescription body article"><P><B>Karl Schroeder</B> lives in Toronto, Ontario.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Tom Doherty Associates
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?0106314b